// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2g-3";
export var dialog = "_2g-0";
export var divClassnameSwatch = "_2g-8";
export var flexSwatch = "_2g-4";
export var header = "_2g-1";
export var styleAttributeSwatch = "_2g-7";
export var swatch = "_2g-2";
export var textHeaderSwatch = "_2g-5";
export var webSwatch = "_2g-6";